export default "__VITE_ASSET__3dc6d668__"